/**
 * Single source of truth for job category / job type / experience level
 * options — used by the employer posting form, admin, filters and card/detail
 * labels, so all of them always agree (previously each file kept its own
 * hardcoded, drifting copy). Existing/legacy values (e.g. "Product") are NOT
 * removed from anywhere they're stored — they just stop being offered as a
 * brand-new option, and still display fine via the `|| rawValue` fallback in
 * the label helpers below.
 */

// Values are canonical identifiers (translated for display via categories.<value>).
export const JOB_CATEGORIES = [
  "Administration", "CustomerService", "Finance", "Construction", "Accounting",
  "Design", "Education", "FoodService", "Tourism", "Engineering", "Legal",
  "Logistics", "Marketing", "Healthcare", "SkilledTrades", "Operations",
  "Manufacturing", "HumanResources", "Retail", "Security", "Services",
  "Technology", "Sales",
];
export const OTHER_CATEGORY = "Other";

export const JOB_TYPES = ["full-time", "part-time", "contract", "temporary", "internship", "freelance", "hourly", "seasonal"];
export const OTHER_JOB_TYPE = "other";

export const EXPERIENCE_LEVELS = ["no_experience", "entry", "junior", "mid", "senior", "lead", "manager", "director", "executive"];
export const OTHER_EXPERIENCE = "other";

export const JOB_TYPE_KEY_MAP = {
  "full-time": "typeFullTime", "part-time": "typePartTime", "contract": "typeContract",
  "temporary": "typeTemporary", "internship": "typeInternship", "freelance": "typeFreelance",
  "hourly": "typeHourly", "seasonal": "typeSeasonal", "other": "typeOther",
};

export const EXPERIENCE_KEY_MAP = {
  no_experience: "expNoExperience", entry: "expEntry", junior: "expJunior", mid: "expMid",
  senior: "expSenior", lead: "expLead", manager: "expManager", director: "expDirector",
  executive: "expExecutive", other: "expOther",
};

export function categoryLabel(value, t) {
  if (!value) return "";
  return t(`categories.${value}`, value);
}

export function jobTypeLabel(value, t) {
  if (!value) return "";
  const key = JOB_TYPE_KEY_MAP[value.replace(/_/g, "-")];
  return key ? t(`jobCard.${key}`, value) : value;
}

export function experienceLabel(value, t) {
  if (!value) return "";
  const key = EXPERIENCE_KEY_MAP[value];
  return key ? t(`jobCard.${key}`, value) : value;
}
